export interface ApplyForm1 {
	matchPurpose: string; // 매칭 목적
	job: string; // 업무 분야
	requestedTask: string; // 요청 업무
	requestedTaskUrl: string; // 요청 업무 URL
	etcJob?: string; // 기타 업무
}

export interface ApplyForm2 {
	desiredStartDate: string; // 매칭 시작일
	expectedWorkload: string; // 예상 업무량
	estimatedBusinessDuration: string; // 예상 기간
	isRemoteWork: string; // 원격 근무 여부
}

export interface ApplyForm3 {
	matchBudget: string; // 매칭 예산
	matchMonthBudget: string; // 월 예산
	govSubsidy: boolean; // 지원금 사용 여부
	promotionCode: string; // 매칭 예산
}

export type SubmitMatch = ApplyForm1 &
	ApplyForm2 &
	ApplyForm3 & {
		notSendConsultingRemind?: boolean;
	};

export interface ReservationMatchRequest {
	matchUuid?: string;
	dateTime?: Date;
}

export interface CallingForm {
	callingDate: string;
	callingTime: string;
}

export interface SignupForm {
	name: string;
	position: string;
	email: string;
	password: string;
	phone: string;
	knownPath: string;
	knownPathDetail: string;
	marketingConsent: boolean;
}

export interface RegistCompanyForm {
	companyName: string;
	companySize: string;
	industry: string;
}

export enum ApplyStep {
	회사정보 = 0,
	스코핑정보 = 1,
	예산정보 = 2,
	그외정보 = 3,
	회원정보 = 4,
	상담예약정보 = 5,
	상담예약완료 = 6,
	숏컨설팅제안 = 7,
	매칭컨설팅없이매칭등록완료 = 8,
}

export interface CompanyData {
	step: ApplyStep.회사정보;
	data: RegistCompanyForm;
}

export interface ApplyData1 {
	step: ApplyStep.스코핑정보;
	data: ApplyForm1;
}

export interface ApplyData2 {
	step: ApplyStep.예산정보;
	data: ApplyForm2;
}

export interface ApplyData3 {
	step: ApplyStep.그외정보;
	data: ApplyForm3;
}
export interface SignupData {
	step: ApplyStep.회원정보;
	data: SignupForm;
}

export interface CallingData {
	step: ApplyStep.상담예약정보;
	data: CallingForm;
}

export type ApplyData =
	| CompanyData
	| ApplyData1
	| ApplyData2
	| ApplyData3
	| SignupData
	| CallingData;

export const companySizeOptionArray = [
	"10명 이하",
	"11~50명",
	"51~200명",
	"201~500명",
	"501명 이상",
];

export const matchPurposeOptionArray = [
	"정규직을 채용하기 위해서",
	"전문적인 자문을 받기 위해서",
	"파트타임 인력이 필요해서",
	"단기 프로젝트 인력이 필요해서",
];

export const matchJobOptionArray = ["마케팅", "디자인", "MD", "기타"];

export const matchBudgetOptionArray = ["4만원 이하", "4만원~7만원", "7만원~10만원", "10만원 이상"];
export const matchMonthBudgetOptionArray = [
	"100만원 이하",
	"100~200만원",
	"200~300만원",
	"300~500만원",
	"500만원 초과",
];

export const expectedWorkloadOptionArray = [
	"주 40시간",
	"주 20시간",
	"주 10시간",
	"주 5시간",
	"추후 결정",
];

export const estimatedBusinessDurationOptionArray = [
	"1개월 이내",
	"1~3개월",
	"3~6개월",
	"6개월 이상",
	"추후 결정",
];

export const desiredStartDateOptionArray = ["최대한 빨리", "2주 이내", "2~4주 이내", "4주 이후"];

export const companyIndustryOptionArray = [
	"소셜미디어/커뮤니티",
	"게임",
	"광고/마케팅",
	"교육",
	"금융/보험/핀테크",
	"모빌리티/교통",
	"물류",
	"부동산/건설",
	"뷰티/화장품",
	"블록체인/딥테크",
	"여행/레저",
	"유아/출산",
	"인사/비즈니스/법률",
	"제조/하드웨어",
	"커머스",
	"컨텐츠/예술",
	"통신/보안/데이터/개발",
	"패션",
	"푸드/농업",
	"헬스케어/바이오",
	"홈리빙/펫",
	"환경/에너지",
];

export const routeOptionArray = [
	"광고",
	"검색",
	"지인 추천",
	"블로그",
	"메일",
	"웨비나",
	"보도자료",
	"커뮤니티",
	"소셜미디어",
	"기타",
];

export const positionOptionArray = ["대표", "임원/C레벨", "팀장/리드", "실무자"];

export interface FixMatchRequestBudget {
	matchBudget: string;
	matchMonthBudget: string;
}
